import React from "react";
import { connect } from "react-redux";
import LocalizedStrings from "react-localization";
import { localisedText } from "../../../lib/localisation.es6";
import PolicyHeader from "./Components/PolicyHeader/PolicyHeader";
import { getEnviroment } from "../../../lib/utils.es6";
// import { getAuthorizationToken } from "../../../lib/access.es6";
import ButtonInc from "../../../shared-ui/ButtonInc";
import { buildAgentParams } from "../shared/agentParams";
import { isOmkAgent } from "../shared/agentView";
import PublicIcon from "@mui/icons-material/Public";
import ComputerIcon from "@mui/icons-material/Computer";

const PRODUCTS = {
  DIASPORA: "diaspora",
  DIGITAL: "digital",
};

class GeneratePolicy extends React.Component {
  constructor(props) {
    const localizedStrings = new LocalizedStrings(localisedText);
    super(props);
    this.state = {
      openRegisterCustomerDialog: false,
      labels: localizedStrings,
      // Agents only sell Digital Last Expense, so the two-card picker is a dead
      // nesting level for them - land straight on the journey. The Diaspora
      // branch, which does not stamp the acting agent onto the policy, becomes
      // unreachable for them as a result.
      selectedProduct: isOmkAgent() ? PRODUCTS.DIGITAL : null,
      hoveredCard: null,
    };
  }

  getIframeSrc(product) {
    const source = "aspin";
    const environment = getEnviroment();
    const isProd = environment === "prod";
    const host_base_url = window.location.origin;

    if (product === PRODUCTS.DIGITAL) {
      const stagingBaseUrl =
        "https://group-portal.staging.aspin-inclusivity.com";
      const productionBaseUrl =
        "https://group-portal.inclusivity-aspin.com";
      const baseUrl = isProd ? productionBaseUrl : stagingBaseUrl;
      return `${baseUrl}/?partner=omk&source=${encodeURIComponent(
        source
      )}&environment=${encodeURIComponent(
        environment
      )}&host_base_url=${encodeURIComponent(
        host_base_url
      )}${buildAgentParams()}`;
    }

    // Diaspora Last Expense
    const stagingBaseUrl =
      "https://ipp-old-mutual-kenya.staging.aspin-inclusivity.com";
    const productionBaseUrl =
      "https://ipp-old-mutual-kenya.inclusivity-aspin.com";
    const baseUrl = isProd ? productionBaseUrl : stagingBaseUrl;
    return `${baseUrl}/?source=${encodeURIComponent(
      source
    )}&environment=${encodeURIComponent(
      environment
    )}&host_base_url=${encodeURIComponent(host_base_url)}`;
  }

  selectProduct(product) {
    this.setState({ selectedProduct: product });
  }

  renderProductCard(config) {
    const { hoveredCard } = this.state;
    const isHovered = hoveredCard === config.product;
    const Icon = config.icon;

    return (
      <div
        onClick={() => this.selectProduct(config.product)}
        onMouseEnter={() => this.setState({ hoveredCard: config.product })}
        onMouseLeave={() => this.setState({ hoveredCard: null })}
        style={{
          position: "relative",
          background: "#FFFFFF",
          border: isHovered
            ? `1px solid ${config.accent}`
            : "1px solid #ECECEC",
          borderRadius: "16px",
          padding: "40px 32px",
          width: "320px",
          textAlign: "center",
          cursor: "pointer",
          transition: "all 0.25s ease",
          transform: isHovered ? "translateY(-6px)" : "translateY(0)",
          boxShadow: isHovered
            ? `0 16px 32px ${config.accentSoft}`
            : "0 4px 14px rgba(0, 0, 0, 0.05)",
        }}
      >
        <div
          style={{
            width: "72px",
            height: "72px",
            margin: "0 auto 24px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: config.accentSoft,
          }}
        >
          <Icon style={{ fontSize: "34px", color: config.accent }} />
        </div>
        <h3
          style={{
            margin: "0 0 10px",
            fontSize: "20px",
            fontWeight: 700,
            color: "#1A1A2E",
          }}
        >
          {config.title}
        </h3>
        <p
          style={{
            margin: "0 0 28px",
            fontSize: "14px",
            lineHeight: 1.6,
            color: "#6B7280",
          }}
        >
          {config.description}
        </p>
        <ButtonInc
          variant="contained"
          onClick={() => this.selectProduct(config.product)}
        >
          Continue
        </ButtonInc>
      </div>
    );
  }

  renderProductSelection() {
    return (
      <section
        style={{
          background:
            "linear-gradient(180deg, #F7F9FC 0%, #FFFFFF 100%)",
          borderRadius: "16px",
          marginTop: "30px",
          marginBottom: "30px",
          width: "100%",
          padding: "72px 20px",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "48px" }}>
          <h1
            style={{
              margin: "0 0 12px",
              fontSize: "28px",
              fontWeight: 800,
              color: "#1A1A2E",
              letterSpacing: "-0.5px",
            }}
          >
            Choose a product to get started
          </h1>
          <p
            style={{
              margin: 0,
              fontSize: "15px",
              color: "#6B7280",
            }}
          >
            Select the type of Last Expense policy you would like to set up.
          </p>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "28px",
            flexWrap: "wrap",
          }}
        >
          {this.renderProductCard({
            product: PRODUCTS.DIASPORA,
            title: "Diaspora Last Expense",
            description:
              "Cover for clients living abroad. Set up and manage Diaspora Last Expense policies.",
            icon: PublicIcon,
            accent: "#2E7D32",
            accentSoft: "rgba(46, 125, 50, 0.12)",
          })}
          {this.renderProductCard({
            product: PRODUCTS.DIGITAL,
            title: "Digital Last Expense",
            description:
              "Fully digital onboarding. Set up and manage Digital Last Expense policies.",
            icon: ComputerIcon,
            accent: "#1565C0",
            accentSoft: "rgba(21, 101, 192, 0.12)",
          })}
        </div>
      </section>
    );
  }

  renderIframe() {
    const { selectedProduct } = this.state;
    const iframeSrc = this.getIframeSrc(selectedProduct);
    const title =
      selectedProduct === PRODUCTS.DIGITAL
        ? "Digital Last Expense"
        : "Diaspora Last Expense";

    return (
      <section
        style={{
          background: "#FFFFFF",
          borderRadius: "8px",
          height: "auto",
          marginTop: "30px",
          marginBottom: "30px",
          width: "100%",
        }}
      >
        {!isOmkAgent() && (
          <div style={{ padding: "16px" }}>
            <ButtonInc
              btnType="secondary"
              variant="outlined"
              onClick={() => this.selectProduct(null)}
            >
              Back to products
            </ButtonInc>
          </div>
        )}
        <iframe
          src={iframeSrc}
          width="100%"
          height="100%"
          style={{
            width: "100%",
            height: "calc(100vh - 160px)",
            border: "none",
          }}
          title={title}
        ></iframe>
      </section>
    );
  }

  render() {
    const { selectedProduct } = this.state;

    return (
      <>
        <PolicyHeader />
        {selectedProduct
          ? this.renderIframe()
          : this.renderProductSelection()}
      </>
    );
  }
}

export default connect((state) => ({
  customerData: state.currentCustomer,
}))(GeneratePolicy);
